import { render, staticRenderFns } from "./InvoicesList.vue?vue&type=template&id=1567c937&scoped=true&"
import script from "./InvoicesList.vue?vue&type=script&lang=ts&"
export * from "./InvoicesList.vue?vue&type=script&lang=ts&"
import style0 from "./InvoicesList.vue?vue&type=style&index=0&id=1567c937&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1567c937",
  null
  
)

/* custom blocks */
import block0 from "./InvoicesList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VBtnToggle,VCard,VCardText,VCol,VDataTable,VRow,VTextField})
